import NpsSetting from "./KrNpsSetting.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrNpsSetting = install(NpsSetting); // 生成带有 install 方法的组件

export default KrNpsSetting;
